import React from 'react';
import { Badge, Group } from '@mantine/core';

import { normalizeTrainingAudiences } from '../../helpers/trainingHelpers';
import {
    getTrainingAudienceBadge,
    TrainingAudience,
} from '../../types/training';

type Props = {
    audiences?: TrainingAudience[] | null;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
};

export function TrainingAudienceBadges({ audiences, size = 'sm' }: Props) {
    return (
        <Group gap={4}>
            {normalizeTrainingAudiences(audiences).map(audience => {
                const { color, label } = getTrainingAudienceBadge(audience);
                return (
                    <Badge
                        key={audience}
                        size={size}
                        variant="light"
                        color={color}
                    >
                        {label}
                    </Badge>
                );
            })}
        </Group>
    );
}
